import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import {Constants} from '../../constants';
import {DataManagementService} from '../../services/data-management.service';
import * as moment from 'moment';
import {RoundNameConstants} from '../../round-name-constants';

@Component({
    selector: 'app-modify-rounds',
    templateUrl: './modify-rounds.component.html',
    styleUrls: ['./modify-rounds.component.css']
})
export class ModifyRoundsComponent implements OnInit {
    @ViewChild('studentsModal') studentsModal: TemplateRef<any>;
    @ViewChild('universitiesModal') universitiesModal: TemplateRef<any>;
    public modalReference: NgbModalRef;
    outgoingTerm;
    selectedOutgoingTerm;
    practiceRound;
    round1;
    round2;
    round3;
    round4;
    confirmationPracticeRound;
    confirmationRound1;
    confirmationRound2;
    confirmationRound3;
    confirmationRound4;
    editingRound;
    showRoundFlag;
    studentsErrorMessage;
    universitiesErrorMessage;
    errorMessage;
    outgoingStudents = [];
    universities = [];
    editRoundFlag;
    termObj;
    selectUndefinedOptionValue;
    practiceRoundNumber = RoundNameConstants.PRACTICE_BIDDING_ROUND;
    round1Number = RoundNameConstants.BIDDING_ROUND_ONE;
    round2Number = RoundNameConstants.BIDDING_ROUND_TWO;
    round3Number = RoundNameConstants.BIDDING_ROUND_THREE;
    round4Number = RoundNameConstants.BIDDING_ROUND_FOUR;
    confirmationPracticeRoundNumber = RoundNameConstants.PRACTICE_CONFIRMATION_ROUND;
    confirmationRound1Number = RoundNameConstants.CONFIRMATION_ROUND1;
    confirmationRound2Number = RoundNameConstants.CONFIRMATION_ROUND2;
    confirmationRound3Number = RoundNameConstants.CONFIRMATION_ROUND3;
    confirmationRound4Number = RoundNameConstants.CONFIRMATION_ROUND4;
    practiceRoundCheckedStudents = [];
    practiceRoundCheckedUniversities = [];
    practiceRoundStudentsBackupObject = {};
    practiceRoundUniversitiesBackupObject = {};
    round1CheckedStudents = [];
    round1CheckedUniversities = [];
    round1StudentsBackupObject = {};
    round1UniversitiesBackupObject = {};
    round2CheckedStudents = [];
    round2CheckedUniversities = [];
    round2StudentsBackupObject = {};
    round2UniversitiesBackupObject = {};
    round3CheckedStudents = [];
    round3CheckedUniversities = [];
    round3StudentsBackupObject = {};
    round3UniversitiesBackupObject = {};
    round4CheckedStudents = [];
    round4CheckedUniversities = [];
    round4StudentsBackupObject = {};
    round4UniversitiesBackupObject = {};
    isTermEnded = false;
    isRanksGenerated = false;

    constructor(private modal: NgbModal,
                private dmService: DataManagementService) {
    }

    getAllTerms() {
        this.dmService.getAll(Constants.TERM_SETTINGS)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.outgoingTerm = response.data.outgoing_terms;
                    } else if (response.status === 'fail') {
                        if (response.data.hasOwnProperty('message')) {
                            this.errorMessage = response.data.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    getOutgoingTermDetails(): void {
        if (this.selectedOutgoingTerm !== undefined && this.selectedOutgoingTerm !== null &&
            this.selectedOutgoingTerm !== '' && this.selectedOutgoingTerm.outgoing_term_id !== undefined) {
            this.isTermEnded = this.selectedOutgoingTerm.is_term_ended;
            this.isRanksGenerated = this.selectedOutgoingTerm.is_ranks_generated;
            if (this.isTermEnded === true || this.isRanksGenerated === true) {
                this.showRoundFlag = true;
                return;
            }
            this.dmService.getOne(Constants.ROUND_SETTINGS, this.selectedOutgoingTerm.outgoing_term_id)
                .subscribe(
                    response => {
                        if (response.status === 'success') {
                            this.clearStudents();
                            this.clearUniversities();
                            this.termObj = response.data;
                            this.outgoingStudents = response.data.outgoing_students;
                            this.universities = response.data.universities;
                            this.practiceRound = {
                                start_time: '',
                                end_time: '',
                                confirmation_start_time: '',
                                confirmation_end_time: ''
                            };
                            this.round1 = {
                                start_time: '',
                                end_time: '',
                                confirmation_start_time: '',
                                confirmation_end_time: ''
                            };
                            this.round2 = {
                                start_time: '',
                                end_time: '',
                                confirmation_start_time: '',
                                confirmation_end_time: ''
                            };
                            this.round3 = {
                                start_time: '',
                                end_time: '',
                                confirmation_start_time: '',
                                confirmation_end_time: ''
                            };
                            this.round4 = {
                                start_time: '',
                                end_time: '',
                                confirmation_start_time: '',
                                confirmation_end_time: ''
                            };
                            this.showRoundFlag = true;
                            if (this.termObj.round_settings.hasOwnProperty(this.practiceRoundNumber)) {
                                this.practiceRound = this.termObj.round_settings[this.practiceRoundNumber];
                                this.practiceRound.start_time = this.getDateTime(this.practiceRound.start_time);
                                this.practiceRound.end_time = this.getDateTime(this.practiceRound.end_time);
                                this.confirmationPracticeRound = this.termObj.round_settings[this.confirmationPracticeRoundNumber];
                                this.practiceRound.confirmation_start_time = this.getDateTime(this.confirmationPracticeRound.start_time);
                                this.practiceRound.confirmation_end_time = this.getDateTime(this.confirmationPracticeRound.end_time);
                                this.practiceRound['confirmation_round_id'] = this.confirmationPracticeRound.outgoing_round_id;
                                if (this.practiceRound.hasOwnProperty('outgoing_students')) {
                                    this.practiceRoundCheckedStudents = [];
                                    for (let i = 0; i < this.practiceRound.outgoing_students.length; i++) {
                                        this.practiceRoundStudentsBackupObject[this.practiceRound.outgoing_students[i]] = true;
                                        this.practiceRoundCheckedStudents.push({
                                            'outgoing_student_id': this.practiceRound.outgoing_students[i],
                                        });
                                    }
                                }
                                if (this.practiceRound.hasOwnProperty('universities')) {
                                    this.practiceRoundCheckedUniversities = [];
                                    for (let i = 0; i < this.practiceRound.universities.length; i++) {
                                        this.practiceRoundUniversitiesBackupObject[this.practiceRound.universities[i]] = true;
                                        this.practiceRoundCheckedUniversities.push({
                                            'university_id': this.practiceRound.universities[i],
                                        });
                                    }
                                }
                            }
                            if (this.termObj.round_settings.hasOwnProperty(this.round1Number)) {
                                this.round1 = this.termObj.round_settings[this.round1Number];
                                this.round1.start_time = this.getDateTime(this.round1.start_time);
                                this.round1.end_time = this.getDateTime(this.round1.end_time);
                                this.confirmationRound1 = this.termObj.round_settings[this.confirmationRound1Number];
                                this.round1.confirmation_start_time = this.getDateTime(this.confirmationRound1.start_time);
                                this.round1.confirmation_end_time = this.getDateTime(this.confirmationRound1.end_time);
                                this.round1['confirmation_round_id'] = this.confirmationRound1.outgoing_round_id;
                                if (this.round1.hasOwnProperty('outgoing_students')) {
                                    this.round1CheckedStudents = [];
                                    for (let i = 0; i < this.round1.outgoing_students.length; i++) {
                                        this.round1StudentsBackupObject[this.round1.outgoing_students[i]] = true;
                                        this.round1CheckedStudents.push({
                                            'outgoing_student_id': this.round1.outgoing_students[i],
                                        });
                                    }
                                }
                                if (this.round1.hasOwnProperty('universities')) {
                                    this.round1CheckedUniversities = [];
                                    for (let i = 0; i < this.round1.universities.length; i++) {
                                        this.round1UniversitiesBackupObject[this.round1.universities[i]] = true;
                                        this.round1CheckedUniversities.push({
                                            'university_id': this.round1.universities[i],
                                        });
                                    }
                                }
                            }
                            if (this.termObj.round_settings.hasOwnProperty(this.round2Number)) {
                                this.round2 = this.termObj.round_settings[this.round2Number];
                                this.round2.start_time = this.getDateTime(this.round2.start_time);
                                this.round2.end_time = this.getDateTime(this.round2.end_time);
                                this.confirmationRound2 = this.termObj.round_settings[this.confirmationRound2Number];
                                this.round2.confirmation_start_time = this.getDateTime(this.confirmationRound2.start_time);
                                this.round2.confirmation_end_time = this.getDateTime(this.confirmationRound2.end_time);
                                this.round2['confirmation_round_id'] = this.confirmationRound2.outgoing_round_id;
                                if (this.round2.hasOwnProperty('outgoing_students')) {
                                    this.round2CheckedStudents = [];
                                    for (let i = 0; i < this.round2.outgoing_students.length; i++) {
                                        this.round2StudentsBackupObject[this.round2.outgoing_students[i]] = true;
                                        this.round2CheckedStudents.push({
                                            'outgoing_student_id': this.round2.outgoing_students[i],
                                        });
                                    }
                                }
                                if (this.round2.hasOwnProperty('universities')) {
                                    this.round2CheckedUniversities = [];
                                    for (let i = 0; i < this.round2.universities.length; i++) {
                                        this.round2UniversitiesBackupObject[this.round2.universities[i]] = true;
                                        this.round2CheckedUniversities.push({
                                            'university_id': this.round2.universities[i],
                                        });
                                    }
                                }
                            }
                            if (this.termObj.round_settings.hasOwnProperty(this.round3Number)) {
                                this.round3 = this.termObj.round_settings[this.round3Number];
                                this.round3.start_time = this.getDateTime(this.round3.start_time);
                                this.round3.end_time = this.getDateTime(this.round3.end_time);
                                this.confirmationRound3 = this.termObj.round_settings[this.confirmationRound3Number];
                                this.round3.confirmation_start_time = this.getDateTime(this.confirmationRound3.start_time);
                                this.round3.confirmation_end_time = this.getDateTime(this.confirmationRound3.end_time);
                                this.round3['confirmation_round_id'] = this.confirmationRound3.outgoing_round_id;
                                if (this.round3.hasOwnProperty('outgoing_students')) {
                                    this.round3CheckedStudents = [];
                                    for (let i = 0; i < this.round3.outgoing_students.length; i++) {
                                        this.round3StudentsBackupObject[this.round3.outgoing_students[i]] = true;
                                        this.round3CheckedStudents.push({
                                            'outgoing_student_id': this.round3.outgoing_students[i],
                                        });
                                    }
                                }
                                if (this.round3.hasOwnProperty('universities')) {
                                    this.round3CheckedUniversities = [];
                                    for (let i = 0; i < this.round3.universities.length; i++) {
                                        this.round3UniversitiesBackupObject[this.round3.universities[i]] = true;
                                        this.round3CheckedUniversities.push({
                                            'university_id': this.round3.universities[i],
                                        });
                                    }
                                }
                            }
                            if (this.termObj.round_settings.hasOwnProperty(this.round4Number)) {
                                this.round4 = this.termObj.round_settings[this.round4Number];
                                this.round4.start_time = this.getDateTime(this.round4.start_time);
                                this.round4.end_time = this.getDateTime(this.round4.end_time);
                                this.confirmationRound4 = this.termObj.round_settings[this.confirmationRound4Number];
                                this.round4.confirmation_start_time = this.getDateTime(this.confirmationRound4.start_time);
                                this.round4.confirmation_end_time = this.getDateTime(this.confirmationRound4.end_time);
                                this.round4['confirmation_round_id'] = this.confirmationRound4.outgoing_round_id;
                                if (this.round4.hasOwnProperty('outgoing_students')) {
                                    this.round4CheckedStudents = [];
                                    for (let i = 0; i < this.round4.outgoing_students.length; i++) {
                                        this.round4StudentsBackupObject[this.round4.outgoing_students[i]] = true;
                                        this.round4CheckedStudents.push({
                                            'outgoing_student_id': this.round4.outgoing_students[i],
                                        });
                                    }
                                }
                                if (this.round4.hasOwnProperty('universities')) {
                                    this.round4CheckedUniversities = [];
                                    for (let i = 0; i < this.round4.universities.length; i++) {
                                        this.round4UniversitiesBackupObject[this.round4.universities[i]] = true;
                                        this.round4CheckedUniversities.push({
                                            'university_id': this.round4.universities[i],
                                        });
                                    }
                                }
                            }
                        } else if (response.status === 'fail') {
                            if (response.data.hasOwnProperty('message')) {
                                this.errorMessage = response.data.message;
                            } else {
                                this.errorMessage = 'Something went wrong. Please contact support team';
                            }
                        }
                        if (this.outgoingStudents.length <= 0) {
                            this.studentsErrorMessage = 'There is no data available for the outgoing students';
                        }
                        if (this.universities.length <= 0) {
                            this.universitiesErrorMessage = 'There is no data available for the universities';
                        }
                    },
                    error => {
                        console.log(error);
                        this.errorMessage = 'Server Error';
                        // this.errorMessage = error;
                    });
        }
    }

    openStudentsModal(round) {
        this.editingRound = round;
        this.modalReference = this.modal.open(this.studentsModal, {size: 'lg', backdrop: 'static', keyboard: false});
    }

    openUniversitiesModal(round) {
        this.editingRound = round;
        this.modalReference = this.modal.open(this.universitiesModal, {size: 'lg', backdrop: 'static', keyboard: false});
    }

    selectStudents(): void {
        this.clearStudents();
        if (this.editingRound === this.practiceRoundNumber) {
            for (let i = 0; i < this.outgoingStudents.length; i++) {
                this.practiceRoundStudentsBackupObject[this.outgoingStudents[i].outgoing_student_id] = true;
                this.practiceRoundCheckedStudents.push({
                    'outgoing_student_id': this.outgoingStudents[i].outgoing_student_id,
                });
            }
        }
        if (this.editingRound === this.round1Number) {
            for (let i = 0; i < this.outgoingStudents.length; i++) {
                this.round1StudentsBackupObject[this.outgoingStudents[i].outgoing_student_id] = true;
                this.round1CheckedStudents.push({
                    'outgoing_student_id': this.outgoingStudents[i].outgoing_student_id,
                });
            }
        }
        if (this.editingRound === this.round2Number) {
            for (let i = 0; i < this.outgoingStudents.length; i++) {
                this.round2StudentsBackupObject[this.outgoingStudents[i].outgoing_student_id] = true;
                this.round2CheckedStudents.push({
                    'outgoing_student_id': this.outgoingStudents[i].outgoing_student_id,
                });
            }
        }
        if (this.editingRound === this.round3Number) {
            for (let i = 0; i < this.outgoingStudents.length; i++) {
                this.round3StudentsBackupObject[this.outgoingStudents[i].outgoing_student_id] = true;
                this.round3CheckedStudents.push({
                    'outgoing_student_id': this.outgoingStudents[i].outgoing_student_id,
                });
            }
        }
        if (this.editingRound === this.round4Number) {
            for (let i = 0; i < this.outgoingStudents.length; i++) {
                this.round4StudentsBackupObject[this.outgoingStudents[i].outgoing_student_id] = true;
                this.round4CheckedStudents.push({
                    'outgoing_student_id': this.outgoingStudents[i].outgoing_student_id,
                });
            }
        }
    }

    clearStudents(): void {
        if (this.editingRound === this.practiceRoundNumber) {
            for (let i = 0; i < this.outgoingStudents.length; i++) {
                for (let j = 0; j < this.practiceRoundCheckedStudents.length; j++) {
                    if (this.practiceRoundCheckedStudents[j].outgoing_student_id === this.outgoingStudents[i].outgoing_student_id) {
                        delete this.practiceRoundStudentsBackupObject[this.practiceRoundCheckedStudents[j].outgoing_student_id];
                        this.practiceRoundCheckedStudents.splice(
                            this.practiceRoundCheckedStudents.indexOf(this.practiceRoundCheckedStudents[j]), 1);
                    }
                }
            }
        }
        if (this.editingRound === this.round1Number) {
            for (let i = 0; i < this.outgoingStudents.length; i++) {
                for (let j = 0; j < this.round1CheckedStudents.length; j++) {
                    if (this.round1CheckedStudents[j].outgoing_student_id === this.outgoingStudents[i].outgoing_student_id) {
                        delete this.round1StudentsBackupObject[this.round1CheckedStudents[j].outgoing_student_id];
                        this.round1CheckedStudents.splice(this.round1CheckedStudents.indexOf(this.round1CheckedStudents[j]), 1);
                    }
                }
            }
        }
        if (this.editingRound === this.round2Number) {
            for (let i = 0; i < this.outgoingStudents.length; i++) {
                for (let j = 0; j < this.round2CheckedStudents.length; j++) {
                    if (this.round2CheckedStudents[j].outgoing_student_id === this.outgoingStudents[i].outgoing_student_id) {
                        delete this.round2StudentsBackupObject[this.round2CheckedStudents[j].outgoing_student_id];
                        this.round2CheckedStudents.splice(this.round2CheckedStudents.indexOf(this.round2CheckedStudents[j]), 1);
                    }
                }
            }
        }
        if (this.editingRound === this.round3Number) {
            for (let i = 0; i < this.outgoingStudents.length; i++) {
                for (let j = 0; j < this.round3CheckedStudents.length; j++) {
                    if (this.round3CheckedStudents[j].outgoing_student_id === this.outgoingStudents[i].outgoing_student_id) {
                        delete this.round3StudentsBackupObject[this.round3CheckedStudents[j].outgoing_student_id];
                        this.round3CheckedStudents.splice(this.round3CheckedStudents.indexOf(this.round3CheckedStudents[j]), 1);
                    }
                }
            }
        }
        if (this.editingRound === this.round4Number) {
            for (let i = 0; i < this.outgoingStudents.length; i++) {
                for (let j = 0; j < this.round4CheckedStudents.length; j++) {
                    if (this.round4CheckedStudents[j].outgoing_student_id === this.outgoingStudents[i].outgoing_student_id) {
                        delete this.round4StudentsBackupObject[this.round4CheckedStudents[j].outgoing_student_id];
                        this.round4CheckedStudents.splice(this.round4CheckedStudents.indexOf(this.round4CheckedStudents[j]), 1);
                    }
                }
            }
        }
    }

    selectUniversities(): void {
        this.clearUniversities();
        if (this.editingRound === this.practiceRoundNumber) {
            for (let i = 0; i < this.universities.length; i++) {
                this.practiceRoundUniversitiesBackupObject[this.universities[i].university_id] = true;
                this.practiceRoundCheckedUniversities.push({
                    'university_id': this.universities[i].university_id,
                });
            }
        }
        if (this.editingRound === this.round1Number) {
            for (let i = 0; i < this.universities.length; i++) {
                this.round1UniversitiesBackupObject[this.universities[i].university_id] = true;
                this.round1CheckedUniversities.push({
                    'university_id': this.universities[i].university_id,
                });
            }
        }
        if (this.editingRound === this.round2Number) {
            for (let i = 0; i < this.universities.length; i++) {
                this.round2UniversitiesBackupObject[this.universities[i].university_id] = true;
                this.round2CheckedUniversities.push({
                    'university_id': this.universities[i].university_id,
                });
            }
        }
        if (this.editingRound === this.round3Number) {
            for (let i = 0; i < this.universities.length; i++) {
                this.round3UniversitiesBackupObject[this.universities[i].university_id] = true;
                this.round3CheckedUniversities.push({
                    'university_id': this.universities[i].university_id,
                });
            }
        }
        if (this.editingRound === this.round4Number) {
            for (let i = 0; i < this.universities.length; i++) {
                this.round4UniversitiesBackupObject[this.universities[i].university_id] = true;
                this.round4CheckedUniversities.push({
                    'university_id': this.universities[i].university_id,
                });
            }
        }
    }

    clearUniversities(): void {
        if (this.editingRound === this.practiceRoundNumber) {
            for (let i = 0; i < this.universities.length; i++) {
                for (let j = 0; j < this.practiceRoundCheckedUniversities.length; j++) {
                    if (this.practiceRoundCheckedUniversities[j].university_id === this.universities[i].university_id) {
                        delete this.practiceRoundUniversitiesBackupObject[this.practiceRoundCheckedUniversities[j].university_id];
                        this.practiceRoundCheckedUniversities.splice(
                            this.practiceRoundCheckedUniversities.indexOf(this.practiceRoundCheckedUniversities[j]), 1);
                    }
                }
            }
        }
        if (this.editingRound === this.round1Number) {
            for (let i = 0; i < this.universities.length; i++) {
                for (let j = 0; j < this.round1CheckedUniversities.length; j++) {
                    if (this.round1CheckedUniversities[j].university_id === this.universities[i].university_id) {
                        delete this.round1UniversitiesBackupObject[this.round1CheckedUniversities[j].university_id];
                        this.round1CheckedUniversities.splice(this.round1CheckedUniversities.indexOf(this.round1CheckedUniversities[j]), 1);
                    }
                }
            }
        }
        if (this.editingRound === this.round2Number) {
            for (let i = 0; i < this.universities.length; i++) {
                for (let j = 0; j < this.round2CheckedUniversities.length; j++) {
                    if (this.round2CheckedUniversities[j].university_id === this.universities[i].university_id) {
                        delete this.round2UniversitiesBackupObject[this.round2CheckedUniversities[j].university_id];
                        this.round2CheckedUniversities.splice(this.round2CheckedUniversities.indexOf(this.round2CheckedUniversities[j]), 1);
                    }
                }
            }
        }
        if (this.editingRound === this.round3Number) {
            for (let i = 0; i < this.universities.length; i++) {
                for (let j = 0; j < this.round3CheckedUniversities.length; j++) {
                    if (this.round3CheckedUniversities[j].university_id === this.universities[i].university_id) {
                        delete this.round3UniversitiesBackupObject[this.round3CheckedUniversities[j].university_id];
                        this.round3CheckedUniversities.splice(this.round3CheckedUniversities.indexOf(this.round3CheckedUniversities[j]), 1);
                    }
                }
            }
        }
        if (this.editingRound === this.round4Number) {
            for (let i = 0; i < this.universities.length; i++) {
                for (let j = 0; j < this.round4CheckedUniversities.length; j++) {
                    if (this.round4CheckedUniversities[j].university_id === this.universities[i].university_id) {
                        delete this.round4UniversitiesBackupObject[this.round4CheckedUniversities[j].university_id];
                        this.round4CheckedUniversities.splice(this.round4CheckedUniversities.indexOf(this.round4CheckedUniversities[j]), 1);
                    }
                }
            }
        }
    }

    getDateTime(date): string {
        if (date === undefined || date === null || date === '' || date === 'undefined') {
            return '';
        }
        return moment(date).subtract(330, 'minutes').format('YYYY-MM-DDTHH:mm');
    }

    addRound(roundNumber): void {
        const that = this;
        let text;
        let addRoundResponse;

        const round = {outgoing_students: [], universities: [], round: 0, user_id: JSON.parse(localStorage.getItem('epas_user')).user_id};
        if (roundNumber === this.practiceRoundNumber) {
            round.outgoing_students = this.practiceRoundCheckedStudents;
            round.universities = this.practiceRoundCheckedUniversities;
            this.practiceRound['outgoing_term_id'] = this.selectedOutgoingTerm.outgoing_term_id;
            this.practiceRound['outgoing_round_name_id'] = this.practiceRoundNumber;
            round.round = this.practiceRound;
            text = '<p>You have selected ' + this.practiceRoundCheckedStudents.length + ' students and '
                + this.practiceRoundCheckedUniversities.length + ' universities to Practice Round?</p>';
        }
        if (roundNumber === this.round1Number) {
            round.outgoing_students = this.round1CheckedStudents;
            round.universities = this.round1CheckedUniversities;
            this.round1['outgoing_term_id'] = this.selectedOutgoingTerm.outgoing_term_id;
            this.round1['outgoing_round_name_id'] = this.round1Number;
            round.round = this.round1;
            text = '<p>You have selected ' + this.round1CheckedStudents.length + ' students and '
                + this.round1CheckedUniversities.length + ' universities to Round 1?</p>';
        }
        if (roundNumber === this.round2Number) {
            round.outgoing_students = this.round2CheckedStudents;
            round.universities = this.round2CheckedUniversities;
            this.round2['outgoing_term_id'] = this.selectedOutgoingTerm.outgoing_term_id;
            this.round2['outgoing_round_name_id'] = this.round2Number;
            round.round = this.round2;
            text = '<p>You have selected ' + this.round2CheckedStudents.length + ' students and '
                + this.round2CheckedUniversities.length + ' universities to Round 2?</p>';
        }
        if (roundNumber === this.round3Number) {
            round.outgoing_students = this.round3CheckedStudents;
            round.universities = this.round3CheckedUniversities;
            this.round3['outgoing_term_id'] = this.selectedOutgoingTerm.outgoing_term_id;
            this.round3['outgoing_round_name_id'] = this.round3Number;
            round.round = this.round3;
            text = '<p>You have selected ' + this.round3CheckedStudents.length + ' students and '
                + this.round3CheckedUniversities.length + ' universities to Round 3?</p>';
        }
        if (roundNumber === this.round4Number) {
            round.outgoing_students = this.round4CheckedStudents;
            round.universities = this.round4CheckedUniversities;
            this.round4['outgoing_term_id'] = this.selectedOutgoingTerm.outgoing_term_id;
            this.round4['outgoing_round_name_id'] = this.round4Number;
            round.round = this.round4;
            text = '<p>You have selected ' + this.round4CheckedStudents.length + ' students and '
                + this.round4CheckedUniversities.length + ' universities to Round 4?</p>';
        }
        Swal({
            type: 'question',
            title: 'Confirm',
            html: text,
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.bulkUpload(round, Constants.ROUND_SETTINGS).subscribe(resData => {
                        addRoundResponse = resData;
                        resolve(addRoundResponse);
                    }, error => {
                        addRoundResponse = error;
                        reject(addRoundResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (addRoundResponse.status === 'success') {
                    let responseMessage = '';
                    if (addRoundResponse.data.hasOwnProperty('message')) {
                        responseMessage = addRoundResponse.data.message;
                    } else {
                        responseMessage = 'Successfully added Round Settings.';
                    }
                    that.getOutgoingTermDetails();
                    Swal({
                        type: 'success',
                        title: 'Success',
                        width: 600,
                        padding: 80,
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: responseMessage,
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                } else if (addRoundResponse.status === 'fail') {
                    Swal({
                        type: 'error',
                        title: 'Fail',
                        width: 600,
                        padding: 80,
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: '<p>Unable to add Round Settings. </p>' + addRoundResponse.data.message,
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                } else {
                    Swal({
                        type: 'error',
                        title: 'Fail',
                        html: '<p>Unable to add Round Settings, Please contact support team.</p>',
                        showCancelButton: false,
                        showConfirmButton: true,
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                }
            }
        }, function (cancel) {
            console.log(cancel);
        });
    }

    updateRound(roundNumber): void {

        const that = this;
        let text;
        let updateRoundResponse;

        const round = {outgoing_students: [], universities: [], round: 0, user_id: JSON.parse(localStorage.getItem('epas_user')).user_id};
        if (roundNumber === this.practiceRoundNumber) {
            round.outgoing_students = this.practiceRoundCheckedStudents;
            round.universities = this.practiceRoundCheckedUniversities;
            this.practiceRound['outgoing_term_id'] = this.selectedOutgoingTerm.outgoing_term_id;
            this.practiceRound['outgoing_round_name_id'] = this.practiceRoundNumber;
            round.round = this.practiceRound;
            text = '<p>You have selected ' + this.practiceRoundCheckedStudents.length + ' students and '
                + this.practiceRoundCheckedUniversities.length + ' universities to Practice Round?</p>';
        }
        if (roundNumber === this.round1Number) {
            round.outgoing_students = this.round1CheckedStudents;
            round.universities = this.round1CheckedUniversities;
            this.round1['outgoing_term_id'] = this.selectedOutgoingTerm.outgoing_term_id;
            this.round1['outgoing_round_name_id'] = this.round1Number;
            round.round = this.round1;
            text = '<p>You have selected ' + this.round1CheckedStudents.length + ' students and '
                + this.round1CheckedUniversities.length + ' universities to Round 1?</p>';
        }
        if (roundNumber === this.round2Number) {
            round.outgoing_students = this.round2CheckedStudents;
            round.universities = this.round2CheckedUniversities;
            this.round2['outgoing_term_id'] = this.selectedOutgoingTerm.outgoing_term_id;
            this.round2['outgoing_round_name_id'] = this.round2Number;
            round.round = this.round2;
            text = '<p>You have selected ' + this.round2CheckedStudents.length + ' students and '
                + this.round2CheckedUniversities.length + ' universities to Round 2?</p>';
        }
        if (roundNumber === this.round3Number) {
            round.outgoing_students = this.round3CheckedStudents;
            round.universities = this.round3CheckedUniversities;
            this.round3['outgoing_term_id'] = this.selectedOutgoingTerm.outgoing_term_id;
            this.round3['outgoing_round_name_id'] = this.round3Number;
            round.round = this.round3;
            text = '<p>You have selected ' + this.round3CheckedStudents.length + ' students and '
                + this.round3CheckedUniversities.length + ' universities to Round 3?</p>';
        }
        if (roundNumber === this.round4Number) {
            round.outgoing_students = this.round4CheckedStudents;
            round.universities = this.round4CheckedUniversities;
            this.round4['outgoing_term_id'] = this.selectedOutgoingTerm.outgoing_term_id;
            this.round4['outgoing_round_name_id'] = this.round4Number;
            round.round = this.round4;
            text = '<p>You have selected ' + this.round4CheckedStudents.length + ' students and '
                + this.round4CheckedUniversities.length + ' universities to Round 4?</p>';
        }
        Swal({
            type: 'question',
            title: 'Confirm',
            html: text,
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.bulkUpload(round, Constants.UPDATE_ROUND_SETTINGS).subscribe(resData => {
                        updateRoundResponse = resData;
                        resolve(updateRoundResponse);
                    }, error => {
                        updateRoundResponse = error;
                        reject(updateRoundResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (updateRoundResponse.status === 'success') {
                    let responseMessage = '';
                    if (updateRoundResponse.data.hasOwnProperty('message')) {
                        responseMessage = updateRoundResponse.data.message;
                    } else {
                        responseMessage = 'Successfully updated Round Settings.';
                    }
                    that.getOutgoingTermDetails();
                    Swal({
                        type: 'success',
                        title: 'Success',
                        width: 600,
                        padding: 80,
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: responseMessage,
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                } else if (updateRoundResponse.status === 'fail') {
                    Swal({
                        type: 'error',
                        title: 'Fail',
                        width: 600,
                        padding: 80,
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: '<p>Unable to update Round Settings. </p>' + updateRoundResponse.data.message,
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                } else {
                    Swal({
                        type: 'error',
                        title: 'Fail',
                        html: '<p>Unable to update Round Settings, Please contact support team.</p>',
                        showCancelButton: false,
                        showConfirmButton: true,
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                }
            }
        }, function (cancel) {
            console.log(cancel);
        });
    }

    toggleStudent(isChecked, student: any) {
        if (this.editingRound === this.practiceRoundNumber) {
            if (isChecked === true) {
                this.practiceRoundStudentsBackupObject[student.outgoing_student_id] = true;
                this.practiceRoundCheckedStudents.push({
                    'outgoing_student_id': student.outgoing_student_id
                });
            } else {
                for (let i = 0; i < this.practiceRoundCheckedStudents.length; i++) {
                    if (this.practiceRoundCheckedStudents[i].outgoing_student_id === student.outgoing_student_id) {
                        delete this.practiceRoundStudentsBackupObject[this.practiceRoundCheckedStudents[i].outgoing_student_id];
                        this.practiceRoundCheckedStudents.splice(
                            this.practiceRoundCheckedStudents.indexOf(this.practiceRoundCheckedStudents[i]), 1);
                    }
                }
            }
        }
        if (this.editingRound === this.round1Number) {
            if (isChecked === true) {
                this.round1StudentsBackupObject[student.outgoing_student_id] = true;
                this.round1CheckedStudents.push({
                    'outgoing_student_id': student.outgoing_student_id
                });
            } else {
                for (let i = 0; i < this.round1CheckedStudents.length; i++) {
                    if (this.round1CheckedStudents[i].outgoing_student_id === student.outgoing_student_id) {
                        delete this.round1StudentsBackupObject[this.round1CheckedStudents[i].outgoing_student_id];
                        this.round1CheckedStudents.splice(this.round1CheckedStudents.indexOf(this.round1CheckedStudents[i]), 1);
                    }
                }
            }
        }
        if (this.editingRound === this.round2Number) {
            if (isChecked === true) {
                this.round2StudentsBackupObject[student.outgoing_student_id] = true;
                this.round2CheckedStudents.push({
                    'outgoing_student_id': student.outgoing_student_id
                });
            } else {
                for (let i = 0; i < this.round2CheckedStudents.length; i++) {
                    if (this.round2CheckedStudents[i].outgoing_student_id === student.outgoing_student_id) {
                        delete this.round2StudentsBackupObject[this.round2CheckedStudents[i].outgoing_student_id];
                        this.round2CheckedStudents.splice(this.round2CheckedStudents.indexOf(this.round2CheckedStudents[i]), 1);
                    }
                }
            }
        }
        if (this.editingRound === this.round3Number) {
            if (isChecked === true) {
                this.round3StudentsBackupObject[student.outgoing_student_id] = true;
                this.round3CheckedStudents.push({
                    'outgoing_student_id': student.outgoing_student_id
                });
            } else {
                for (let i = 0; i < this.round3CheckedStudents.length; i++) {
                    if (this.round3CheckedStudents[i].outgoing_student_id === student.outgoing_student_id) {
                        delete this.round3StudentsBackupObject[this.round3CheckedStudents[i].outgoing_student_id];
                        this.round3CheckedStudents.splice(this.round3CheckedStudents.indexOf(this.round3CheckedStudents[i]), 1);
                    }
                }
            }
        }
        if (this.editingRound === this.round4Number) {
            if (isChecked === true) {
                this.round4StudentsBackupObject[student.outgoing_student_id] = true;
                this.round4CheckedStudents.push({
                    'outgoing_student_id': student.outgoing_student_id
                });
            } else {
                for (let i = 0; i < this.round4CheckedStudents.length; i++) {
                    if (this.round4CheckedStudents[i].outgoing_student_id === student.outgoing_student_id) {
                        delete this.round4StudentsBackupObject[this.round4CheckedStudents[i].outgoing_student_id];
                        this.round4CheckedStudents.splice(this.round4CheckedStudents.indexOf(this.round4CheckedStudents[i]), 1);
                    }
                }
            }
        }
    }

    toggleUniversity(isChecked, university: any) {
        if (this.editingRound === this.practiceRoundNumber) {
            if (isChecked === true) {
                this.practiceRoundUniversitiesBackupObject[university.university_id] = true;
                this.practiceRoundCheckedUniversities.push({
                    'university_id': university.university_id
                });
            } else {
                for (let i = 0; i < this.practiceRoundCheckedUniversities.length; i++) {
                    if (this.practiceRoundCheckedUniversities[i].university_id === university.university_id) {
                        delete this.practiceRoundUniversitiesBackupObject[this.practiceRoundCheckedUniversities[i].university_id];
                        this.practiceRoundCheckedUniversities.splice(
                            this.practiceRoundCheckedUniversities.indexOf(this.practiceRoundCheckedUniversities[i]), 1);
                    }
                }
            }
        }
        if (this.editingRound === this.round1Number) {
            if (isChecked === true) {
                this.round1UniversitiesBackupObject[university.university_id] = true;
                this.round1CheckedUniversities.push({
                    'university_id': university.university_id
                });
            } else {
                for (let i = 0; i < this.round1CheckedUniversities.length; i++) {
                    if (this.round1CheckedUniversities[i].university_id === university.university_id) {
                        delete this.round1UniversitiesBackupObject[this.round1CheckedUniversities[i].university_id];
                        this.round1CheckedUniversities.splice(this.round1CheckedUniversities.indexOf(this.round1CheckedUniversities[i]), 1);
                    }
                }
            }
        }
        if (this.editingRound === this.round2Number) {
            if (isChecked === true) {
                this.round2UniversitiesBackupObject[university.university_id] = true;
                this.round2CheckedUniversities.push({
                    'university_id': university.university_id
                });
            } else {
                for (let i = 0; i < this.round2CheckedUniversities.length; i++) {
                    if (this.round2CheckedUniversities[i].university_id === university.university_id) {
                        delete this.round2UniversitiesBackupObject[this.round2CheckedUniversities[i].university_id];
                        this.round2CheckedUniversities.splice(this.round2CheckedUniversities.indexOf(this.round2CheckedUniversities[i]), 1);
                    }
                }
            }
        }
        if (this.editingRound === this.round3Number) {
            if (isChecked === true) {
                this.round3UniversitiesBackupObject[university.university_id] = true;
                this.round3CheckedUniversities.push({
                    'university_id': university.university_id
                });
            } else {
                for (let i = 0; i < this.round3CheckedUniversities.length; i++) {
                    if (this.round3CheckedUniversities[i].university_id === university.university_id) {
                        delete this.round3UniversitiesBackupObject[this.round3CheckedUniversities[i].university_id];
                        this.round3CheckedUniversities.splice(this.round3CheckedUniversities.indexOf(this.round3CheckedUniversities[i]), 1);
                    }
                }
            }
        }
        if (this.editingRound === this.round4Number) {
            if (isChecked === true) {
                this.round4UniversitiesBackupObject[university.university_id] = true;
                this.round4CheckedUniversities.push({
                    'university_id': university.university_id
                });
            } else {
                for (let i = 0; i < this.round4CheckedUniversities.length; i++) {
                    if (this.round4CheckedUniversities[i].university_id === university.university_id) {
                        delete this.round4UniversitiesBackupObject[this.round4CheckedUniversities[i].university_id];
                        this.round4CheckedUniversities.splice(this.round4CheckedUniversities.indexOf(this.round4CheckedUniversities[i]), 1);
                    }
                }
            }
        }
    }

    saveStudents(): void {
        Swal({type: 'success', title: 'Success', text: 'Successfully Saved Students for Round.', timer: 1500});
        this.modalReference.close();
    }

    saveUniversities(): void {
        Swal({type: 'success', title: 'Success', text: 'Successfully Saved Universities for Round.', timer: 1500});
        this.modalReference.close();
    }

    closeModal(): void {
        this.editRoundFlag = false;
        this.modalReference.close();
    }

    ngOnInit() {
        this.getAllTerms();
    }

}
